<div class="account-dialog">
    <div class="seperator"></div>
    <div class="title" mat-dialog-title>Forget password</div>
    <div class="dialog-body{{sent?' emailsent-body':''}}">
        <form *ngIf="sent===false" class="forget-password-form">
            <div class="form-text">Type your email below to reset your password</div>
            <mat-form-field class="form-field">
                <input type="email" matInput placeholder="Email Address" [formControl]="emailFormControl">
                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                    Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                    Email is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <button mat-raised-button (click)="sendEmail()" class="rubii-btn submit-button" color="primary">Reset password</button>
        </form>
        <ng-container *ngIf="sent">
            <div>Please check your email for the link to reset password.</div>
            <div class="text-gap">If you are still having difficulties logging in, please contact support@rubii.io</div>
        </ng-container>
    </div>
</div>